import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

export const WordingSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 3: WORDING & PERSONALIZATION</h3>

    <div>
      <Label htmlFor="exactNames" className="text-charcoal-ink">Exact Name(s) to Appear on Designs *</Label>
      <Textarea
        id="exactNames"
        required
        value={formData.exactNames}
        onChange={(e) => set('exactNames', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[80px]"
      />
    </div>

    <div>
      <Label htmlFor="exactPhrasing" className="text-charcoal-ink">Exact Phrase or Wording Needed *</Label>
      <Textarea
        id="exactPhrasing"
        required
        value={formData.exactPhrasing}
        onChange={(e) => set('exactPhrasing', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[80px]"
        placeholder='e.g., "Happy Birthday Ava," "Welcome to the Baby Shower"'
      />
    </div>

    <div>
      <Label htmlFor="specialDetails" className="text-charcoal-ink">Age, Date, or Special Details to Include (if applicable)</Label>
      <Input
        id="specialDetails"
        value={formData.specialDetails}
        onChange={(e) => set('specialDetails', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
      <p className="text-xs text-stone-taupe mt-1">⚠️ Please double-check spelling and dates. The Favor is not responsible for errors after approval.</p>
    </div>
  </div>
);
